import { Field } from 'formik';
import { Textarea, FormControl, Grid, GridItem } from '@chakra-ui/react';

import ElementHeading from '../../formElements/components/ElementHeading';
import ElementInstructions from '../../formElements/components/ElementInstructions';
import { getUsefulVars } from '../../handlers/helpers';
import InputWrapper from '../../formElements/components/InputWrapper';
import ElementErrorMessage from '../../formElements/components/ElementErrorMessage';
import { transformRSInput } from '../../formControllers/Transformation/Utils';
import { save } from '../../handlers';

const StartTextarea = ({  qObj, props,resumeIndex }) => {

  const index = resumeIndex;
  const jobSeekerData = props.formikProps.values.jobSeekerData;
    const fieldName ="jobSeekerData["+index+"][\""+qObj.qid+"\"]";
  return (
    <Field name={fieldName}>
      {({ field, form }) => {
        return(
        <FormControl isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}>
          <ElementHeading qObj={qObj} props={props} />
          <ElementInstructions instructions={qObj.instructions} />
          <InputWrapper>
            <Textarea
              placeholder={qObj.placeholder}
              {...field}
              onChange={e => {
              transformRSInput(e, jobSeekerData, index, qObj, props);
            }
            }
              onBlur={e => {
                save(props.stateProps,index);
              }
              }
            />
          </InputWrapper>
          <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
        </FormControl>
      )}}
    </Field>
  );
};

export default StartTextarea;
/*

              onBlur={e => {
                if (sectionName === 'parser') {
                  clearResume(e, form, field, props);
                }
              }
              }
              onChange={e => {
                transformRSInput(e, jobSeekerData, index, qObj, props);
              }
              }
 */


/*
  let fieldValue = '';
  if (qObj.qid === 'job_posting' && sectionName=== 'job-posting') {
    if(jobSeekerData[index] === undefined) {
      fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
    } else {
      if (jobSeekerData[index][sectionName] === undefined) {
        fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
      } else {
        if (jobSeekerData[index][sectionName][0] === undefined) {
          fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
        } else {
          if (jobSeekerData[index][sectionName][0][qObj.qid] === undefined) {
            fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'][0];
          } else {
            fieldValue = jobSeekerData[index][qObj.qid][0]['job_posting'];
          }
        }
      }
    }
  }
  */
/*
if (qObj.qid === 'job_posting') {
    if (!jobSeekerData[index][sectionName] ||
    !jobSeekerData[index][sectionName][0] ||
    jobSeekerData[index][sectionName][0][qObj.qid] === undefined) {
    fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'];
  }
      fieldValue = props.stateProps.dataToSave.saved.resumes[index]['job-posting'];
    } else {
      fieldValue = jobSeekerData[index][qObj.qid];
    }
  }*/
/*
let fieldValue = (sectionName ==='job-posting' &&
  qObj.qid === 'job_posting' &&
  (jobSeekerData[index][qObj.qid] === undefined )) ? props.stateProps.dataToSave.saved.resumes[index]['job-posting']: jobSeekerData[index][qObj.qid];
fieldValue = jobSeekerData[index][qObj.qid];
*/